import { ApiClient } from '@webapp/core/services/ApiClient'
import { StatementItemRepository } from './StatementItemRepository'

export const statementItemRepository = new StatementItemRepository({
  httpClient: ApiClient,
})
